module.exports = __webpack_public_path__ + "static/24-75c447edd28207ad06bcb8c6e6b67c24.jpg";